import React, { useState, useEffect, Fragment,useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Card, Container, Modal, Form, Row, Col, Button, InputGroup, Spinner } from 'react-bootstrap'
import {LoadingComponent} from 'recupero-comunes'
import { useFormik } from 'formik'
import {validationSchemasAtenderInformeProfesional, campoEsRequerido} from '../../common/validation-Schemas-atender-informe-profesional';
import { formatearNumero, isValidParam, validaNumeros } from '../../common/Formatos'
import {serviceGetCfgForm, serviceGetLesiones, serviceGestionarInforme} from '../../api/api-atender-informe-profesional';
import { esArchivoGrande, subirArchivoGrandeS3 } from '../../common/uploadArchivoGranTamano';
import { serviceObtieneParametro } from '../../api/api-parametros';
import Mensajes from '../mensajes.js'
import {CarpetaDigitalComponent} from 'defcol-caso-general'

const AtenderInformeMedico = ({ showModal, setShowModal, idCaso, idOrgCaso, solicitud, handleReload, idTrxOrigen}) => {

    const {state}=useLocation()
    const fileRef = useRef();
    const [cfg_form, setCfg_form] = useState(null);
    const [loading, setLoading] = useState(false);

    const [showToast, setShowToast] = useState(false);
    const handleShowToast = () => setShowToast(true) 
    const [respuestaGestion, setRespuestaGestion] = useState({});

    const [tiposLesiones, setTiposLesiones] = useState([]);

    const [nroFicha, setNroFicha] = React.useState('')
    const [fechaInforme, setFechaInforme] = React.useState('') 
    const [incapProvicional, setIncapProvicional] = React.useState('')
    const [nivelLesion, setNivelLesion] = React.useState('')
    const [incapDefinitiva, setIncapDefinitiva] = React.useState('')
    const [gastosMedicos, setGastosMedicos] = React.useState('')
    const [gastosMedicosSinFormato, setGastosMedicosSinFormato] = React.useState('')
    const [deficiencia, setDeficiencia] = React.useState('')
    const [gastosMedicosFut, setGastosMedicosFut] = React.useState('')
    const [gastosMedicosFutSinFormato, setGastosMedicosFutSinFormato] = React.useState('')
    const [rolLaboral, setRolLaboral] = React.useState('')
    const [perdidaCapLab, setPerdidaCapLab] = React.useState('')
    const [cifraSugerida, setCifraSugerida] = React.useState('')
    const [cifraSugeridaSinFormato, setCifraSugeridaSinFormato] = React.useState('')

    const [comentarios, setComentarios] = React.useState('')
    const [fechaMin, setFechaMin]=useState('')

    const [limites, setLimites] = useState({ liviano: 8 * 1000000, pesado: 20 * 1000000 });
    const [showConfirmGrande, setShowConfirmGrande] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    const archivoSubidoRef = useRef({ file: null, s3Bucket: null, s3Key: null });

    useEffect(() => {
        if (showModal) {
            getTiposLesiones();
            handleLimpiar();
            getCfgForm(idOrgCaso);
            obtenerLimites();
        }
    }, [showModal])

    const obtenerLimites = async () => {
        const [liviano, pesado] = await Promise.all([serviceObtieneParametro(52), serviceObtieneParametro(53)]);
        setLimites({ liviano, pesado });
    }

    const handleFileChange = (e) => {
        const file = e.currentTarget.files[0];
        if (!file) return;

        if (esArchivoGrande(file, limites.liviano)) {
            setPendingFile(file);
            setShowConfirmGrande(true);
        } else {
            formik.setFieldValue("file", file);
        }
    }

    const handleCancelArchivoGrande = () => {
        setPendingFile(null);
        if (fileRef.current) fileRef.current.value = "";
        setShowConfirmGrande(false);
    }

    const handleConfirmArchivoGrande = () => {
        formik.setFieldValue("file", pendingFile);
        setShowConfirmGrande(false);
    }

    const getCfgForm = async (idOrgBien) => {
        const query = Buffer.from(JSON.stringify({ rutcia: idOrgBien, idform: 93 })).toString('base64');
        const response = await serviceGetCfgForm(query);
        setCfg_form(response);
    }

    const getTiposLesiones = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 203 })).toString('base64');
        const response = await serviceGetLesiones(query);

        setTiposLesiones(response);
    }

    const handleCloseToast = () => {
        setShowToast(false);
        handleLimpiar();
        setShowModal(false);
        handleReload();
    }
    const handleLimpiar = () => {
        formik.resetForm();   
        setComentarios("");
        setFechaInforme("");
        setNroFicha("");
        setIncapProvicional("");
        setNivelLesion("");
        setIncapDefinitiva("");
        setGastosMedicos("");
        setGastosMedicosSinFormato("");
        setDeficiencia("");
        setGastosMedicosFut("");
        setGastosMedicosFutSinFormato("");
        setRolLaboral("");
        setPerdidaCapLab("");
        setCifraSugerida("");
        setCifraSugeridaSinFormato("");
        setFechaMin("");
    }

    const handleClose = () => {
        setShowModal(false);
    }
    const schema = validationSchemasAtenderInformeProfesional(solicitud.codTipoInforme, limites.pesado);

    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "idUsuario": "",
            "nroFicha": "",
            "fechaInforme": "",
            "incapProvicional": "",
            "nivelLesion": "",
            "incapDefinitiva": "",
            "gastosMedicos": "",
            "deficiencia": "",
            "gastosMedicosFut": "",
            "rolLaboral": "",
            "perdidaCapLab": "",
            "cifraSugerida": "",
            "comentarios": "",
        },
        validationSchema: validationSchemasAtenderInformeProfesional(solicitud.codTipoInforme, limites.pesado),
        onSubmit: async (formData) => {

            let dataForm = {
                ...formData
            }
            dataForm['idCaso'] = idCaso;
            dataForm['idOrganizacion'] = idOrgCaso;
            dataForm['idSolicitud'] = solicitud.idSolicitud;
            dataForm['accion'] = 3;//Atender Informe Médico
            dataForm['idImplicado'] = solicitud.idImplicado;
            dataForm['tipoInforme'] = solicitud.codTipoInforme;

            dataForm['montoGastosMedicos'] = gastosMedicosSinFormato;
            dataForm['montoGastosMedicosFut'] = gastosMedicosFutSinFormato;
            dataForm['montoSugerido'] = cifraSugeridaSinFormato;
            dataForm['idTrxOrigen'] = idTrxOrigen;

            setLoading(true);

            try {
                let fileData = null;

                if (formData.file) {
                    if (esArchivoGrande(formData.file, limites.liviano)) {
                        let archivoRef;
                        if (archivoSubidoRef.current.file === formData.file) {
                            archivoRef = archivoSubidoRef.current;
                        } else {
                            archivoRef = await subirArchivoGrandeS3(formData.file);
                            archivoSubidoRef.current = { file: formData.file, ...archivoRef };
                        }
                        fileData = { filename: formData.file.name, mimetype: formData.file.type, s3Bucket: archivoRef.s3Bucket, s3Key: archivoRef.s3Key };
                    } else {
                        const base64data = await getBase64(formData.file);
                        fileData = { filename: formData.file.name, mimetype: formData.file.type, base64data: base64data.split(',')[1] };
                    }
                }

                let data = { ...dataForm };
                if (fileData) data.file = fileData;

                const response = await serviceGestionarInforme(data);
                setRespuestaGestion(response);
                handleShowToast(true);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.error(error.message);
                alert(error.message);
            }
        }
    })
    const hoy = () => {
        const fecha = new Date()
        const hoy = fecha.toISOString().split('T')[0]
        return hoy
    }
    const [showCarpeta, setShowCarpeta] = useState(false)
    const handleShowCarpeta = () => setShowCarpeta(true)
    const handleCloseCarpeta= () => setShowCarpeta(false) 
return (
    <div>
        <Fragment>
            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
                <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
                    idCaso={solicitud && solicitud.idCaso}
                    idImplicado={solicitud && solicitud.idImplicado}
                    idOrganizacionCaso={solicitud && solicitud.idOrgBien}
                    prototipo={2}            
                />   
            </Modal>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='xl'>
                <LoadingComponent show={loading}/>
                <Form onSubmit={formik.handleSubmit}>
                <Card >
                    <Card.Header className='cardHeader'>
                        {(cfg_form && cfg_form["atender-informemed-titleing"]) ? cfg_form["atender-informemed-titleing"] : 'Atender Informe Médico'} - ID Caso {idCaso} 
                    </Card.Header>
                    <Card.Body>

                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '18px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-title-datsin"]) ? cfg_form["atender-informemed-title-datsin"] : 'Datos del Siniestro'}
                                </Form.Label>
                            </Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='2'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-datsin-sin"]) ? cfg_form["atender-informemed-datsin-sin"] : 'Siniestro'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['siniestro']) ? solicitud['siniestro'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='2'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-datsin-placa"]) ? cfg_form["atender-informemed-datsin-placa"] : 'Placa'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['placa']) ? solicitud['placa'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='2'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-datsin-fechasig"]) ? cfg_form["atender-informemed-datsin-fechasig"] : 'Fecha Asignación'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['fecSolicitudFormat']) ? solicitud['fecSolicitudFormat'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='3'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-datsin-respsol"]) ? cfg_form["atender-informemed-datsin-respsol"] : 'Responsable CIA Solicita'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['responsableSolicita']) ? solicitud['responsableSolicita'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='3'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-datsin-comentario"]) ? cfg_form["atender-informemed-datsin-comentario"] : 'Comentario CIA'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['comentario']) ? solicitud['comentario'] : null}
                                </Form.Text>
                            </Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '18px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-title-datimpl"]) ? cfg_form["atender-informemed-title-datimpl"] : 'Datos Implicado'}
                                </Form.Label>
                            </Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='4'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-datimpl-nitimpl"]) ? cfg_form["atender-informemed-datimpl-nitimpl"] : 'NIT Tercero'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['rutImplicado']) ? solicitud['rutImplicado'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='4'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-datimpl-nomimpl"]) ? cfg_form["atender-informemed-datimpl-nomimpl"] : 'Nombre/Razón Social'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['implicado']) ? solicitud['implicado'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='4'></Col>
                        </Row>

                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '18px' }}>
                                    {(cfg_form && cfg_form["atender-informemed-title-datinf"]) ? cfg_form["atender-informemed-title-datinf"] : 'Datos del Informe'}
                                </Form.Label>
                            </Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-histclin']) ? cfg_form && cfg_form['atender-informemed-datinf-input-histclin'] : 'Historia Clínica'}
                                    {campoEsRequerido(schema, 'nroFicha') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <Form.Control
                                    className='mt-2'
                                    autoComplete='off'
                                    value={(formik.values.nroFicha = nroFicha !== undefined && nroFicha)}      
                                    onChange={(e) => {
                                        formik.handleChange(e)
                                        setNroFicha(e.target.value)
                                    }}                                              
                                    name='nroFicha'
                                    error={formik.errors.nroFicha}
                                ></Form.Control>
                                {formik.errors.nroFicha && formik.touched.nroFicha &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.nroFicha}
                                    </Form.Text>
                                }
                            </Col>
                            <Col></Col>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-fechainf']) ? cfg_form && cfg_form['atender-informemed-datinf-input-fechainf'] : 'Fecha Informe'}
                                    {campoEsRequerido(schema, 'fechaInforme') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <Form.Control 
                                    className='mb-0' 
                                    type='date'
                                    value={(formik.values.fechaInforme = fechaInforme)}
                                    min={fechaMin && fechaMin}
                                    max={hoy()}
                                    name='fechaInforme'
                                    onChange={
                                        (e) => {
                                            formik.handleChange(e)
                                            setFechaInforme(e.target.value)
                                        }
                                    }
                                    error={formik.errors.fechaInforme}
                                >                                                    
                                </Form.Control>
                                {formik.errors.fechaInforme ? (
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.fechaInforme}
                                    </Form.Text>
                                    ) : (
                                    ''
                                )}                                        
                            </Col>
                            <Col md='2'></Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-incapprovi']) ? cfg_form && cfg_form['atender-informemed-datinf-input-incapprovi'] : 'Incapacidad Provisional'}
                                    {campoEsRequerido(schema, 'incapProvicional') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <Form.Control
                                    autoComplete='off'
                                    type="number"
                                    value={(formik.values.incapProvicional = incapProvicional !== undefined && incapProvicional)}      
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || (Number(value) >= 0)) {
                                            formik.handleChange(e)
                                            setIncapProvicional(e.target.value)
                                        }
                                    }}               
                                    onKeyDown={(e) => validaNumeros(e)}                               
                                    name='incapProvicional'
                                    error={formik.errors.incapProvicional}
                                ></Form.Control>
                                {formik.errors.incapProvicional && formik.touched.incapProvicional &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.incapProvicional}
                                    </Form.Text>
                                }
                            </Col>
                            <Col></Col>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-lesiones']) ? cfg_form && cfg_form['atender-informemed-datinf-input-lesiones'] : 'Lesiones'}
                                    {campoEsRequerido(schema, 'nivelLesion') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <Form.Select  aria-label='Default select example'
                                    onChange={(e) => {
                                            formik.handleChange(e)
                                            setNivelLesion(e.target.value)
                                        }
                                    }
                                    name='nivelLesion'
                                    value={(formik.values.nivelLesion = nivelLesion)}
                                    error={formik.errors.nivelLesion}>
                                    <option value={''}>Seleccione...</option>
                                    {tiposLesiones && tiposLesiones ?. map((c) => (
                                        <option key={c.id} value={c.id}>
                                            {c.nombre} 
                                        </option>
                                        ))
                                    } 
                                </Form.Select>
                                {formik.errors.nivelLesion && formik.touched.nivelLesion &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.nivelLesion}
                                    </Form.Text>
                                }                                       
                            </Col>
                            <Col md='3'></Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-incapdef']) ? cfg_form && cfg_form['atender-informemed-datinf-input-incapdef'] : 'Incapacidad Definitiva'}
                                    {campoEsRequerido(schema, 'incapDefinitiva') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <Form.Control
                                    autoComplete='off'
                                    type="number"
                                    value={(formik.values.incapDefinitiva = incapDefinitiva !== undefined && incapDefinitiva)}      
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || (Number(value) >= 0)) {
                                            formik.handleChange(e)
                                            setIncapDefinitiva(e.target.value)
                                        }
                                    }}                           
                                    onKeyDown={(e) => validaNumeros(e)}                   
                                    name='incapDefinitiva'
                                    error={formik.errors.incapDefinitiva}
                                ></Form.Control>
                                {formik.errors.incapDefinitiva && formik.touched.incapDefinitiva &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.incapDefinitiva}
                                    </Form.Text>
                                }
                            </Col>
                            <Col></Col>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-gastmed']) ? cfg_form && cfg_form['atender-informemed-datinf-input-gastmed'] : 'Gastos Médicos'}
                                    {campoEsRequerido(schema, 'gastosMedicos') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <Form.Control
                                    className='mt-2'
                                    aria-label='Default select example'
                                    autoComplete='off'
                                    onKeyDown={(e) => validaNumeros(e)}
                                    onBlur={() => {
                                        setGastosMedicos(formatearNumero(gastosMedicos, false))
                                    }}
                                    onFocus={() => setGastosMedicos(gastosMedicosSinFormato)}
                                    onChange={(e) => {
                                        formik.handleChange(e)
                                        setGastosMedicos(e.target.value)
                                        setGastosMedicosSinFormato(e.target.value)                                                                                                            
                                    }}
                                    name='gastosMedicos'
                                    value={(formik.values.gastosMedicos = gastosMedicos)}
                                    error={formik.errors.gastosMedicos}
                                ></Form.Control> 
                                {formik.errors.gastosMedicos ? (
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {formik.errors.gastosMedicos}
                                    </Form.Text>
                                ) : (
                                    ''
                                )}                                       
                            </Col>
                            <Col md='3'></Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-defici']) ? cfg_form && cfg_form['atender-informemed-datinf-input-defici'] : 'Deficiencia'}
                                    {campoEsRequerido(schema, 'deficiencia') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <InputGroup className='mt-2'>
                                    <Form.Control
                                        autoComplete='off'
                                        type="number"
                                        value={(formik.values.deficiencia = deficiencia !== undefined && deficiencia)}      
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
                                                formik.handleChange(e)
                                                setDeficiencia(e.target.value)
                                            }
                                        }}            
                                        onKeyDown={(e) => validaNumeros(e)}                                  
                                        name='deficiencia'
                                        error={formik.errors.deficiencia}
                                    ></Form.Control>
                                <InputGroup.Text>%</InputGroup.Text>
                                </InputGroup>
                                {formik.errors.deficiencia && formik.touched.deficiencia &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.deficiencia}
                                    </Form.Text>
                                }
                            </Col>
                            <Col></Col>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-gastmedfut']) ? cfg_form && cfg_form['atender-informemed-datinf-input-gastmedfut'] : 'Gastos Médicos Futuros'} 
                                    {campoEsRequerido(schema, 'gastosMedicosFut') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <Form.Control
                                    className='mt-2'
                                    aria-label='Default select example'
                                    autoComplete='off'
                                    onKeyDown={(e) => validaNumeros(e)}
                                    onBlur={() => {
                                        setGastosMedicosFut(formatearNumero(gastosMedicosFut, false))
                                    }}
                                    onFocus={() => setGastosMedicosFut(gastosMedicosFutSinFormato)}
                                    onChange={(e) => {
                                        formik.handleChange(e)
                                        setGastosMedicosFut(e.target.value)
                                        setGastosMedicosFutSinFormato(e.target.value)                                                                                                            
                                    }}
                                    name='gastosMedicosFut'
                                    value={(formik.values.gastosMedicosFut = gastosMedicosFut)}
                                    error={formik.errors.gastosMedicosFut}
                                ></Form.Control> 
                                {formik.errors.gastosMedicosFut ? (
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {formik.errors.gastosMedicosFut}
                                    </Form.Text>
                                ) : (
                                    ''
                                )}                                       
                            </Col>
                            <Col md='6'></Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-rollaboral']) ? cfg_form && cfg_form['atender-informemed-datinf-input-rollaboral'] : 'Rol Laboral/Ocupacional y Otros'}
                                    {campoEsRequerido(schema, 'rolLaboral') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <InputGroup className='mt-2'>
                                    <Form.Control
                                        autoComplete='off'
                                        type="number"
                                        value={(formik.values.rolLaboral = rolLaboral !== undefined && rolLaboral)}      
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
                                                formik.handleChange(e)
                                                setRolLaboral(e.target.value)
                                            }
                                        }}                                
                                        onKeyDown={(e) => validaNumeros(e)}              
                                        name='rolLaboral'
                                        error={formik.errors.rolLaboral}
                                    ></Form.Control> 
                                    <InputGroup.Text>%</InputGroup.Text>
                                </InputGroup>
                                {formik.errors.rolLaboral && formik.touched.rolLaboral &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.rolLaboral}
                                    </Form.Text>
                                }
                            </Col>            
                            <Col md='7'></Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-perdcap']) ? cfg_form && cfg_form['atender-informemed-datinf-input-perdcap'] : 'Pérdida Cap.Laboral (PLC)'}
                                    {campoEsRequerido(schema, 'perdidaCapLab') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <InputGroup className='mt-2'>
                                    <Form.Control
                                        autoComplete='off'
                                        type="number"
                                        value={(formik.values.perdidaCapLab = perdidaCapLab !== undefined && perdidaCapLab)}      
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
                                                formik.handleChange(e)
                                                setPerdidaCapLab(e.target.value)
                                            }
                                        }}        
                                        onKeyDown={(e) => validaNumeros(e)}                                      
                                        name='perdidaCapLab'
                                        error={formik.errors.perdidaCapLab}
                                    ></Form.Control>
                                    <InputGroup.Text>%</InputGroup.Text>
                                </InputGroup>
                                {formik.errors.perdidaCapLab && formik.touched.perdidaCapLab &&
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.perdidaCapLab}
                                    </Form.Text>
                                }
                            </Col>
                            <Col></Col>
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-montosugerido']) ? cfg_form && cfg_form['atender-informemed-datinf-input-montosugerido'] : 'Monto Sugerido'}
                                    {campoEsRequerido(schema, 'cifraSugerida') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md='2'>
                                <Form.Control
                                    className='mt-2'
                                    aria-label='Default select example'
                                    autoComplete='off'
                                    onKeyDown={(e) => validaNumeros(e)}
                                    onBlur={() => {
                                        setCifraSugerida(formatearNumero(cifraSugerida, false))
                                    }}
                                    onFocus={() => setCifraSugerida(cifraSugeridaSinFormato)}
                                    onChange={(e) => {
                                        formik.handleChange(e)
                                        setCifraSugerida(e.target.value)
                                        setCifraSugeridaSinFormato(e.target.value)                                                                                                            
                                    }}
                                    name='cifraSugerida'
                                    value={(formik.values.cifraSugerida = cifraSugerida)}
                                    error={formik.errors.cifraSugerida}
                                ></Form.Control> 
                                {formik.errors.cifraSugerida ? (
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {formik.errors.cifraSugerida}
                                    </Form.Text>
                                ) : (
                                    ''
                                )}                                       
                            </Col>
                            <Col md='3'></Col>
                        </Row>
                        <Row>
                           <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-comentarios']) ? cfg_form && cfg_form['atender-informemed-datinf-input-comentarios'] : 'Comentarios'} 
                                    {campoEsRequerido(schema, 'comentarios') && <span> *</span>}
                                </Form.Label>
                            </Col>
                            <Col md="8">
                                <Form.Control as='textarea' className='mb-2'
                                    rows={2}
                                    onChange={
                                        (e) => {
                                            formik.handleChange(e)
                                            setComentarios(e.target.value)
                                        }
                                    }
                                    name='comentarios'
                                    value={
                                        (formik.values.comentarios = comentarios)
                                    }
                                    error={
                                        formik.errors.comentarios
                                    }/>
                                    {formik.errors.comentarios ? (
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {formik.errors.comentarios}
                                        </Form.Text>
                                        ) : (
                                        ''
                                    )}
                            </Col>   
                            <Col md='1'></Col> 
                        </Row>     
                        <Row>          
                            <Col md='3'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informemed-datinf-input-subirdcto']) ? cfg_form && cfg_form['atender-informemed-datinf-input-subirdcto'] : 'Informe médico (PDF)'} *
                                </Form.Label>
                            </Col>
                            <Col md="8">
                                <Form.Group className="position-relative mb-2 mt-1">
                                    <Form.Control ref={fileRef} type="file" name="file"
                                        onChange={handleFileChange} onBlur={formik.handleBlur}
                                        isInvalid={!!formik.errors.file}
                                        isValid={formik.touched.file && !formik.errors.file}
                                    />
                                    <Form.Text className="text-muted">{`Tamaño máximo del archivo: ${limites.pesado / 1000000}MB`}</Form.Text>
                                    <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                                </Form.Group>                                                
                            </Col>
                            <Col md='1'></Col>
                        </Row>
                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                        <Row className='containerHeader'>
                            <Col className="d-grid d-md-flex justify-content-md-end">
                                <Button style={{ width: '110px', marginRight: '5px' }} variant='outline-info' onClick={handleClose}>
                                    {(cfg_form && cfg_form["atender-informemed-btncerrar"]) ? cfg_form["atender-informemed-btncerrar"] : 'Cerrar'}
                                </Button>
                                <Button style={{ width: '130px', marginRight: '5px' }} variant='carpeta' onClick={handleShowCarpeta}>
                                    {(cfg_form && cfg_form["atender-informemed-btncarpeta"]) ? cfg_form["atender-informemed-btncarpeta"] : 'Documentos'}
                                </Button>
                                <Button style={{ width: '135px', color: 'white' }} variant='solicitar' type='onSubmit' disabled={loading}>
                                    {loading && <Spinner as="span" animation="border" size="sm" className="me-2" />}
                                    {(cfg_form && cfg_form["atender-informemed-btnsolicitar"]) ? cfg_form["atender-informemed-btnsolicitar"] : 'Registrar Informe'}
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Container>
                    <Row>
                        <Col>
                            {respuestaGestion && 
                                <Mensajes
                                    showToast={showToast}
                                    handleCloseToast={handleCloseToast}
                                    delay={5000}
                                    responseData={respuestaGestion}
                                ></Mensajes>
                            }
                        </Col>
                    </Row>
                </Container>
                </Form>
            </Modal>

            <Modal show={showConfirmGrande} onHide={handleCancelArchivoGrande} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Confirmación
                    </Card.Header>
                    <Card.Body>
                        {`El archivo seleccionado supera los ${limites.liviano / 1000000}MB, por lo que la carga puede demorar más de lo habitual. ¿Desea continuar?`}
                    </Card.Body>
                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={handleCancelArchivoGrande}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={handleConfirmArchivoGrande}>Sí</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <style type='text/css'>
                {`
                    .cardHeader {
                        background-color: #77789b;
                        color: #FFFFFF;
                    }
                    .containerHeader {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 5px;
                    }
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                        padding: 1rem;
                    }
                    .customHeaderCard {
                        background-color: #676999;
                        color: #fff;
                        font-size: 17px;
                        font-weight: 600;
                        text-align: center;
                        text-decoration: underline;
                    }
                    .cursor {
                        cursor: pointer;
                    }
                    .btn-carpeta {
                        background-color: #F0AD3E;
                        color: #FFFFFF;
                        width: 140px;                    
                    }
                    .btn-carpeta:hover{
                        background-color:#e1b97f;
                        color: #FFFFFF;
                    }
                    .btn-solicitar {
                        background-color: #C14B49;
                        color: #FFFFFF;
                        width: 140px;
                        padding:6px 0px 6px 0px;
                    }
                    .btn-solicitar:hover{
                        background-color:  #F6897E;
                        color: #FFFFFF;
                    }
                `}
            </style>         
        </Fragment>
    </div>
  )
}
export default AtenderInformeMedico

const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
};